module.exports = __webpack_public_path__ + "img/txt_series_101.00050167.png";